import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../../redux";
import { AddOfferButton } from "./add-offer-button";
import { AddOfferModal } from "./add-offer-modal";
import { MarketplaceGrid } from "./marketplace-grid";
import { Person } from "@radivision/graphql/lib/ts/graphql/person";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";
import { isOwner } from "../../../../utilities/is-owner";
import isEmpty from "lodash.isempty";

interface ComponentProps {
  entity: Entity & { marketplace: any };
}

interface MapDispatchProps {}
interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const MarketplacePanelComponent = (props: Props) => {
  const { entity, user } = props;
  const owner = isOwner(entity, user);

  return (
    <div className="tab-pane" id="Marketplace">
      {owner ? (
        <>
          <AddOfferButton entity={entity} />
          <AddOfferModal />
        </>
      ) : null}
      <MarketplaceGrid entityId={entity?.id} owner={owner} />
    </div>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = () => ({});

export const MarketplacePanel = connect(mapState, mapDispatch)(MarketplacePanelComponent);
